"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var buildQueryParameters_1 = __importDefault(require("./buildQueryParameters"));
var DEFAULT_REQUEST_TIMEOUT = 25000;
var timeoutPromise = function (ms, promise) {
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            reject(new Error('timeout'));
        }, ms);
        promise.then(resolve, reject);
    });
};
function fetchOsmoServer(params, raw, timeout) {
    var _this = this;
    if (raw === void 0) { raw = false; }
    if (timeout === void 0) { timeout = DEFAULT_REQUEST_TIMEOUT; }
    var headers = {
        Accept: 'application/json',
    };
    if (params.method === 'POST' ||
        params.method === 'PUT' ||
        params.method === 'PATCH') {
        if (typeof FormData !== 'undefined' &&
            params.body &&
            params.body instanceof FormData) {
            if (!params.noContentType) {
                headers['Content-Type'] = 'multipart/form-data';
            }
        }
        else {
            headers['Content-Type'] = 'application/json';
        }
    }
    if (params.requestToken) {
        headers['X-OSMO-Request-Token'] = params.requestToken;
    }
    if (params.userAgent) {
        headers['X-Osmo-User-Agent'] = params.userAgent;
    }
    if (params.accountCreationToken) {
        headers['X-osmo-account-creation-token'] = params.accountCreationToken;
    }
    var data = {
        method: params.method || 'GET',
        headers: headers,
    };
    if (params.credentials) {
        data.credentials = params.credentials;
    }
    if (params.body) {
        if (typeof FormData !== 'undefined' && params.body instanceof FormData) {
            data.body = params.body;
        }
        else {
            data.body = JSON.stringify(params.body);
        }
    }
    var endpoint = params.endpoint;
    if (params.urlParams) {
        endpoint += (0, buildQueryParameters_1.default)(params.urlParams);
    }
    var apiUrl = params.apiUrl;
    var url = "".concat(apiUrl).concat(endpoint);
    return timeoutPromise(timeout || DEFAULT_REQUEST_TIMEOUT, fetch(url, data)).then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var output, _a, _b, _c, error_1;
        var _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _d = {
                        success: !!response.ok,
                        status: response.status,
                        statusText: response.statusText
                    };
                    if (!raw) return [3, 2];
                    return [4, response.clone().text()];
                case 1:
                    _a = _e.sent();
                    return [3, 3];
                case 2:
                    _a = '';
                    _e.label = 3;
                case 3:
                    output = (_d.rawResponse = _a,
                        _d.data = null,
                        _d);
                    _e.label = 4;
                case 4:
                    _e.trys.push([4, 9, , 10]);
                    _b = output;
                    if (!raw) return [3, 6];
                    return [4, response.clone().json()];
                case 5:
                    _c = _e.sent();
                    return [3, 8];
                case 6: return [4, response.json()];
                case 7:
                    _c = _e.sent();
                    _e.label = 8;
                case 8:
                    _b.data = _c;
                    return [3, 10];
                case 9:
                    error_1 = _e.sent();
                    return [2, __assign(__assign({}, output), { error: error_1 })];
                case 10: return [2, output];
            }
        });
    }); });
}
exports.default = fetchOsmoServer;
